/* eslint-disable max-lines */
/* eslint-disable max-len */
import React, {useMemo} from 'react';
import {useTable, usePagination, useFilters, useRowSelect} from 'react-table';
import {Table} from 'semantic-ui-react';
import {Filter, InventoryColumnFilter} from '../internalCommons/TableFilters';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import {cloneDeep} from 'lodash';
import '../styles.scss';
import {Link} from 'react-router-dom';
import {LoaderDetailList} from '../internalCommons/loaderDetailList';


const jsonToParams = (json) => {
  return Object.keys(json).map((key) => {
    return `${encodeURIComponent(key)}=${encodeURIComponent(json[key])}`;
  }).join('&');
};

const stockColumns = (isUserTde, requestData) => {
  const dealerHiddenColums = ['not_available'];
  const columns = [
    {
      'Header': () => <span className="header-title">DISPONIBLE</span>,
      'accessor': 'available',
      'width': 150,
      'className': 'cell-custom-inventory-models link-cell',
      'groupClassName': 'color-group-stock border-left',
      'Cell': ({row}) => {
        const params = {
          'master': row.original.model,
          'sfx': row.original.sfx,
          'dealer': requestData.dealer,
          'destiny': requestData.destiny,
        };
        return (
          <Link
            className='no-space'
            to={`/vehiculos/administracion-inventario/${row.original.model}?group=stock&type=available&${jsonToParams(params)}`}
          >
            {row.original.available || 0}
          </Link>
        );
      },
    },
    {
      'Header': () => <span className="header-title">PRIORIZADOS</span>,
      'accessor': 'prioritized',
      'width': 150,
      'className': 'cell-custom-inventory-models link-cell',
      'groupClassName': 'color-group-stock',
      'Cell': ({row}) => {
        const params = {
          'master': row.original.model,
          'sfx': row.original.sfx,
          'dealer': requestData.dealer,
          'destiny': requestData.destiny,
        };
        return (
          <Link
            className='no-space'
            to={`/vehiculos/administracion-inventario/${row.original.model}?group=stock&type=prioritized&${jsonToParams(params)}`}
          >
            {row.original.prioritized || 0}
          </Link>
        );
      },
    },
    {
      'Header': () => <span className="header-title">NO DISPONIBLE</span>,
      'accessor': 'not_available',
      'width': 150,
      'className': 'cell-custom-inventory-models link-cell',
      'groupClassName': 'color-group-stock',
      'Cell': ({row}) => {
        const params = {
          'master': row.original.model,
          'sfx': row.original.sfx,
          'dealer': requestData.dealer,
          'destiny': requestData.destiny,
        };
        return (
          <Link
            className='no-space'
            to={`/vehiculos/administracion-inventario/${row.original.model}?group=stock&type=not_available&${jsonToParams(params)}`}
          >
            {row.original.not_available || 0}
          </Link>
        );
      },
    },
    {
      'Header': () => <span className="header-title">TOTAL</span>,
      'accessor': 'totalStock',
      'width': 150,
      'className': 'cell-custom-inventory-models link-cell border-right color-total',
      'groupClassName': 'color-group-stock border-right',
      'Cell': ({row}) => {
        const params = {
          'master': row.original.model,
          'sfx': row.original.sfx,
          'dealer': requestData.dealer,
          'destiny': requestData.destiny,
        };
        return (
          <Link
            className='no-space'
            to={`/vehiculos/administracion-inventario/${row.original.model}?group=stock&type=totalStock&${jsonToParams(params)}`}
          >
            {row.original.totalStock || 0}
          </Link>
        );
      },
    },
  ];
  if (isUserTde) {
    return columns;
  }
  return columns.filter((column) => !dealerHiddenColums.includes(column.accessor));
};


const tableHeaderWithProps = (requestData, isUserTde) => {
  return [
    {
      'Header': () => <span className="header-title"></span>,
      'id': 'total',
      'columns': [
        {
          'Header': () => <span className="header-title">VEHÍCULO</span>,
          'accessor': 'description',
          'width': 150,
          'className': 'cell-custom-inventory-models width-order-big align-left',
        },
        {
          'Header': () => <span className="header-title">KATASHIKI</span>,
          'accessor': 'model',
          'width': 150,
          'className': 'cell-custom-inventory-models width-order-big',
        },
        {
          'Header': () => <span className="header-title">SFX</span>,
          'accessor': 'sfx',
          'width': 150,
          'className': 'cell-custom-inventory-models width-order-medium',
        },
      ],
    },
    {
      'Header': () => <span className="header-title">TRÁNSITO</span>,
      'id': 'transitGroup',
      'groupClassName': 'color-group-transit border-left',
      'columns': [
        {
          'Header': () => <span className="header-title">DEPÓSITO</span>,
          'accessor': 'deposit',
          'width': 250,
          'className': 'cell-custom-inventory-models link-cell border-left',
          'groupClassName': 'color-group-transit border-left',
          'Cell': ({row}) => {
            const params = {
              'master': row.original.model,
              'sfx': row.original.sfx,
              'dealer': requestData.dealer,
              'destiny': requestData.destiny,
            };
            return (
              <Link
                className='no-space'
                to={`/vehiculos/administracion-inventario/${row.original.model}?group=transit&type=deposit&${jsonToParams(params)}`}
              >
                {row.original.deposit || 0}
              </Link>
            );
          },
        },
        {
          'Header': () => <span className="header-title">TRÁNSITO</span>,
          'accessor': 'transit',
          'width': 250,
          'className': 'cell-custom-inventory-models link-cell',
          'groupClassName': 'color-group-transit',
          'Cell': ({row}) => {
            const params = {
              'master': row.original.model,
              'sfx': row.original.sfx,
              'dealer': requestData.dealer,
              'destiny': requestData.destiny,
            };
            return (
              <Link
                className='no-space'
                to={`/vehiculos/administracion-inventario/${row.original.model}?group=transit&type=transit&${jsonToParams(params)}`}
              >
                {row.original.transit || 0}
              </Link>
            );
          },
        },
        {
          'Header': () => <span className="header-title">TOTAL</span>,
          'accessor': 'totalTransit',
          'width': 150,
          'className': 'cell-custom-inventory-models link-cell border-right color-total',
          'groupClassName': 'color-group-transit',
          'Cell': ({row}) => {
            const params = {
              'master': row.original.model,
              'sfx': row.original.sfx,
              'dealer': requestData.dealer,
              'destiny': requestData.destiny,
            };
            return (
              <Link
                className='no-space'
                to={`/vehiculos/administracion-inventario/${row.original.model}?group=transit&type=totalTransit&${jsonToParams(params)}`}
              >
                {row.original.totalTransit || 0}
              </Link>
            );
          },
        },
      ],
    },
    {
      'Header': () => <span className="header-title">STOCK TDE</span>,
      'id': 'stockGroup',
      'groupClassName': 'color-group-stock border-left border-right',
      'columns': stockColumns(isUserTde, requestData),
    },
    {
      'Header': () => <span className="header-title"></span>,
      'id': 'total',
      'columns': [
        {
          'Header': () => <span className="header-title">TOTAL UNIDADES</span>,
          'accessor': 'totalUnits',
          'width': 150,
          'className': 'cell-custom-inventory-models width-order-medium',
          'Cell': ({row}) => (
            <span className='no-space'>
              {row.original.totalUnits || 0}
            </span>
          ),
        },
      ],
    },
  ];
};

const SummaryModelTable = ({dataModels, requestData, loading, isUserTde}) => {
  const clone = cloneDeep(dataModels);
  const columnsTable = tableHeaderWithProps(requestData, isUserTde);
  const data = useMemo(() => clone, [dataModels]);
  const columns = useMemo(() => columnsTable, [requestData]);

  const {getTableProps, getTableBodyProps, headerGroups, prepareRow, page} =
    useTable(
      {
        columns,
        data,
        'defaultColumn': {'Filter': InventoryColumnFilter},
        'initialState': {'pageIndex': 0, 'pageSize': 100000},
        requestData,
      },
      useFilters,
      usePagination,
      useRowSelect
    );

  return (
    <>
      <div className="table-wrapper inventory-table">
        <Table className="interactive" compact {...getTableProps()}>
          <Table.Header className="sticky z-index-10">
            {headerGroups.map((headerGroup) => (
              <Table.Row key="headers" {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => {
                  return (
                    <Table.HeaderCell
                      key={`title-${index}`}
                      textAlign="center"
                      className= {`${column.groupClassName} th-semanctic-custom`}
                      {...column.getHeaderProps()}
                    >
                      {column.render('Header')}
                    </Table.HeaderCell>
                  );
                })}
              </Table.Row>
            ))}
            {
              !loading && (
                <Table.Row key="filters" id="filters">
                  {headerGroups[1].headers.map((column, index) => {
                    return (
                      <Table.HeaderCell
                        key={`filter-${index}`}
                        textAlign="center"
                        className={`${[3, 6, 9].includes(index) ? 'border-left' : 'none'}`}>
                        <Filter column={column} />
                      </Table.HeaderCell>
                    );
                  }
                  )}
                </Table.Row>
              )
            }
          </Table.Header>
          <Table.Body {...getTableBodyProps()}>
            { loading ? (
              <LoaderDetailList />
            ) :
              (<>
                {!page.length && (
                  <Table.Row>
                    <Table.Cell colSpan={15} textAlign="center">
                      No hay datos disponibles
                    </Table.Cell>
                  </Table.Row>
                )}
                {page.length > 0 &&
              page.map((row, i) => {
                prepareRow(row);
                return (
                  <Table.Row
                    key={i}
                    className={`
                      row-custom cell-custom-inventory-models ${i % 2 === 0 ? 'table-row-odd' : 'table-row-even'}
                    `}>
                    {row.cells.map((cell) => {
                      return (
                        <Table.Cell
                          textAlign="center"
                          className={cell.column.className}
                        >
                          {cell.render('Cell')}
                        </Table.Cell>
                      );
                    })}
                  </Table.Row>
                );
              })}
              </>)
            }
            
          </Table.Body>
        </Table>
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  'listDealers': state.dealer.list,
  'updateTable': state.manageOrders.updateTable,
  'loading': state.vehiclesInventory.loading,
  'isUserTde': state.session.isUserFromTDE,
});

const {fetchOrigins} = Actions;

export default connect(mapStateToProps, {
  fetchOrigins,
})(SummaryModelTable);
